<template>
    <div class="mains" v-if="isShow">
        <div class="container group_">
            <div class="header">
                <span>GMV累计交易金额</span>
                <span @click="exitLogin" style="cursor: pointer;color:#FFFFFF" class="el-icon-close"></span>
            </div>
            <div class="center">
                <div class="nav">
                    <span>累计交易金额(亿)</span>
                    <span>{{ totalTradeAmount }}</span>
                </div>
                <div class="nav">
                    <span>商城累计交易金额(万)</span>
                    <span>{{ mallTotalTradeAmount }}</span>
                </div>
                <div class="nav">
                    <span>活畜累计交易金额(万)</span>
                    <span>{{ liveTotalTradeAmount }}</span>
                </div>
                <div class="nav">
                    <span>活畜屠宰收购交易金额(万)</span>
                    <span>{{ slaughterTradeAmount }}</span>
                </div>
            </div>
            <!-- 图表 -->
            <div class="conter">
                <div class="left">
                    <div class="grow">
                        <span class="grow_item">交易增长趋势</span>
                        <div class="grow_">
                            <el-date-picker v-model="value1" type="daterange" range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                            <img @click="delteDate(1)" style="cursor:pointer" src="../../assets/refresh.png" alt="">
                        </div>
                    </div>
                    <div class="all">
                        <span @click="conterActiveBtn('全部')" :class="{ active: conterActive === '全部' }">全部</span>
                        <span @click="conterActiveBtn('商城')" :class="{ active: conterActive === '商城' }">商城</span>
                        <span @click="conterActiveBtn('活畜')" :class="{ active: conterActive === '活畜' }">活畜</span>
                        <span @click="conterActiveBtn('屠宰收购')" :class="{ active: conterActive === '屠宰收购' }">屠宰收购</span>
                    </div>
                    <div class="day">
                        <div class="day_">
                            <span>今日交易金额</span>
                            <span class="day_item">{{ myTradeGrowTrend.todayTradeAmount }}<i>万元</i></span>
                        </div>
                        <div class="day_">
                            <span>昨日交易金额</span>
                            <span class="day_item">{{ myTradeGrowTrend.yesterdayTradeAmount }}<i>万元</i></span>
                        </div>
                        <div class="day_">
                            <span>交易总额<i>{{ myTradeGrowTrend.tradeAmount }}</i>万元</span>
                            <span>日均交易<i>{{ myTradeGrowTrend.everydayTradeAmount }}</i>万元</span>
                        </div>
                    </div>
                    <div id="lineChart"></div>
                </div>
                <div class="right">
                    <div class="grow">
                        <span class="grow_item">交易分布占比</span>
                        <div class="grow_">
                            <el-date-picker @change="changeDate" v-model="value2" type="daterange" range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                            <img @click="delteDate(2)" style="cursor:pointer" src="../../assets/refresh.png" alt="">
                        </div>
                    </div>
                    <div id="pieChart"></div>
                </div>
            </div>
            <!-- 底部地图 -->
            <div class="footer">
                <div class="grow">
                    <span class="grow_item">地域分析</span>
                    <div class="grow_">
                        <el-date-picker v-model="value3" type="daterange" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                        <img @click="delteDate(3)" style="cursor:pointer" src="../../assets/refresh.png" alt="">
                    </div>
                </div>
                <div class="footer_">
                    <div class="left">
                        <div class="all">
                            <span @click="regionActiveBtn('全部')" :class="{ active: regionActive === '全部' }">全部</span>
                            <span @click="regionActiveBtn('商城')" :class="{ active: regionActive === '商城' }">商城</span>
                            <span @click="regionActiveBtn('活畜')" :class="{ active: regionActive === '活畜' }">活畜</span>
                            <span @click="regionActiveBtn('屠宰收购')"
                                :class="{ active: regionActive === '屠宰收购' }">屠宰收购</span>
                        </div>
                        <div v-if="isShowMap" id="chinaChart"></div>
                    </div>
                    <div class="right">
                        <div class="all">
                            <span v-if="show" @click="regionActiveBtns('运营中心')"
                                :class="{ active: regionActiveStatus === '运营中心' }">运营中心</span>
                            <span @click="regionActiveBtns('区域合伙人')"
                                :class="{ active: regionActiveStatus === '区域合伙人' }">区域合伙人</span>
                            <span @click="regionActiveBtns('畜牧科技师')"
                                :class="{ active: regionActiveStatus === '畜牧科技师' }">畜牧科技师</span>
                            <span :class="{ only: show === false }">总量<i>{{ terrainAnalysis.total }}</i></span>
                        </div>
                        <el-table ref='table' style="margin-top:0.2rem;overflow: scroll;" :data="tableData"
                            height="5rem" :row-style="{ height: '5px' }" :cell-style="{ padding: '0' }" align="center"
                            header-align="center">
                            <el-table-column show-overflow-tooltip property="serialNum" width="50" label="序号">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="name" width="100"
                                label="合伙人姓名">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip align="center" property="tradeAmount" width="72"
                                label="交易额">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip property="prop" width="320" label="占比">
                                <template slot-scope="scope">
                                    <span style="width: 40px; height:20px;display: inline-block;position: absolute;top:11px;left:0">{{ scope.row.prop +
                                            '%'
                                    }}</span>
                                    <span
                                        style="position: relative;top: 6px;width:4rem;height:20px;display:inline-block;background: rgba(32,91,203,0.2);margin-left: .55rem;">

                                    </span>
                                    <span class="change2"
                                        style="height:20px;background: linear-gradient(180deg, #2C75FD 0%, #3A7DFF 100%);position: absolute;top: 14px;left: 62px;"></span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {

    },
    data() {
        return {
            a: 20,
            isShow: false,
            // info: '',
            headerInfo: {},
            userInfo: {},
            value1: [],
            value2: [],
            value3: [],
            tableData: [],
            conterActive: '全部',
            regionActive: '全部',
            regionActiveStatus: '运营中心',
            screenData: {},
            totalTradeAmount: '', // 累计交易金额(亿)
            mallTotalTradeAmount: '', // 商城累计交易金额(万)
            liveTotalTradeAmount: '', // 活畜累计交易金额(万)
            slaughterTradeAmount: '', // 活畜屠宰收购交易金额(万)
            tradeGrowTrend: {},// 交易增长趋势
            myTradeGrowTrend: {},//存储单个交易增长趋势
            // tradeDisProp: {},交易分布占比
            terrainAnalysis: {},//地域分析数据
            show: true,
            isShowMap: true,
            mapMainChart: null
        };
    },
    created() {
        this.headerInfo = {
            name: window.localStorage.getItem('screenName')
        }
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))
    },
    mounted() {
    },
    // 销毁定时器
    destroyed() {

    },
    // 日期过滤
    filters: {

    },
    methods: {
        // 交易增长趋势切换
        conterActiveBtn(val) {
            if (val === '全部') {
                this.conterActive = '全部'
                this.myTradeGrowTrend = this.tradeGrowTrend.all
            }
            if (val === '商城') {
                this.conterActive = '商城'
                this.myTradeGrowTrend = this.tradeGrowTrend.mall
            }
            if (val === '活畜') {
                this.conterActive = '活畜'
                this.myTradeGrowTrend = this.tradeGrowTrend.live
            }
            if (val === '屠宰收购') {
                this.conterActive = '屠宰收购'
                this.myTradeGrowTrend = this.tradeGrowTrend.slaughterAcquisition
            }
            this.lineChart(this.myTradeGrowTrend.tradeAmountData, this.myTradeGrowTrend.orderSize)
        },
        // 地域分析左侧切换
        regionActiveBtn(val) {
            if (val === '全部') {
                this.regionActive = '全部'
                this.show = true
                this.regionActiveStatus = '运营中心'
                this.terrainAnalysis = this.screenData.terrainAnalysis.all
                this.tableData = this.terrainAnalysis.operatingCenter
            }
            if (val === '商城') {
                this.regionActive = '商城'
                this.show = false
                this.regionActiveStatus = '区域合伙人'
                this.terrainAnalysis = this.screenData.terrainAnalysis.mall
                this.tableData = this.terrainAnalysis.areaPartner
            }
            if (val === '活畜') {
                this.regionActive = '活畜'
                this.show = false
                this.regionActiveStatus = '区域合伙人'
                this.terrainAnalysis = this.screenData.terrainAnalysis.live
                this.tableData = this.terrainAnalysis.areaPartner
            }
            if (val === '屠宰收购') {
                this.regionActive = '屠宰收购'
                this.show = false
                this.regionActiveStatus = '区域合伙人'
                this.terrainAnalysis = this.screenData.terrainAnalysis.slaughterAcquisition
                this.tableData = this.terrainAnalysis.areaPartner
            }
            this.change()
            if (this.mapMainChart != null && this.mapMainChart != "" && this.mapMainChart != undefined) {
                this.isShowMap = false
                this.mapMainChart.dispose()
            }
            this.$nextTick(() => {
                this.isShowMap = true
                // setTimeout(() => {
                //     this.draw(this.region, this.terrainAnalysis)
                // }, 100)
            })
            this.getMap()//获取地图数据

        },
        // 地域分析右侧切换
        regionActiveBtns(val) {
            if (val === '运营中心') {
                this.regionActiveStatus = '运营中心'
                this.tableData = this.terrainAnalysis.operatingCenter
            }
            if (val === '区域合伙人') {
                this.regionActiveStatus = '区域合伙人'
                // if (this.regionActive =='商城') {
                //     this.terrainAnalysis = this.screenData.terrainAnalysis.mall
                // }
                // if (this.regionActive =='活畜') {
                // this.terrainAnalysis = this.screenData.terrainAnalysis.live
                // }
                // if (this.regionActive == '屠宰收购') {
                //     this.terrainAnalysis = this.screenData.terrainAnalysis.slaughterAcquisition
                // }
                this.tableData = this.terrainAnalysis.areaPartner
            }
            if (val === '畜牧科技师') {
                this.regionActiveStatus = '畜牧科技师'
                // if (this.regionActive == '商城') {
                //     this.terrainAnalysis = this.screenData.terrainAnalysis.mall
                // }
                // if (this.regionActive == '活畜') {
                //     this.terrainAnalysis = this.screenData.terrainAnalysis.live
                // }
                // if (this.regionActive == '屠宰收购') {
                //     this.terrainAnalysis = this.screenData.terrainAnalysis.slaughterAcquisition
                // }
                this.tableData = this.terrainAnalysis.livestock
            }
            this.change()
        },
        changeDate(val) {
            console.log(val);
        },
        delteDate(val) {
            if (val == 1) this.value1 = []
            if (val == 2) this.value2 = []
            if (val == 3) this.value3 = []
        },
        change() {
            this.$nextTick(() => {
                document.querySelectorAll('.change2').forEach((item, index) => {
                    item.style.width = this.tableData[index]['prop'] * 3.2 + 'px'
                })
            })
            // document.querySelector('.change2').style.width = this.a + 'px'
        },
        showModel() {
            this.isShow = true
            this.$nextTick(() => {
                this.getList()
            })
        },
        hideModel() {
            this.isShow = false
        },
        // 折柱混合图
        lineChart(data1, data2) {
            var myChart = this.$echarts.init(document.getElementById('lineChart'));
            var option = {
                legend: {
                    top: '10%',
                    // // left: '3%',
                    right: '5%',
                    // bottom: '60%',
                    // show: true,
                    data: [
                        {
                            name: '交易金额',
                            textStyle: {
                                color: '#1ea5f9'
                            },
                        },
                        {
                            name: '订单量',
                            textStyle: {
                                color: '#5c35f7'
                            },
                            bottom: 10
                        }
                    ]
                },
                grid: {
                    top: '35%',
                    height: "48%",
                    // containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    show: true,
                    axisLine: {
                        lineStyle: {
                            color: '#11296D',//x轴线条颜色宽度
                            width: 1
                        }
                    },
                    axisLabel: { color: '6FB6FF' },//x轴刻度文字颜色
                    scale: false,
                    axisTick: { show: false },
                    data: data1.label

                },
                yAxis: [{
                    type: 'value',
                    name: '交易价格(元)',
                    alignTicks: true,
                    offset: 10,
                    splitNumber: 3,
                    axisLine: {
                        lineStyle: {
                            color: '#6FB6FF'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: '#0c1d55'
                        }
                    },
                    axisTick: { show: false },
                },
                {
                    type: 'value',
                    name: '',
                    alignTicks: true,
                    offset: 10,
                    axisLine: {
                        lineStyle: {
                            color: '#6FB6FF'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: '#0c1d55'
                        }
                    },
                    axisTick: { show: false },
                }
                ],
                series: [
                    {
                        name: '交易金额',
                        data: data1.value,
                        type: 'bar',
                        symbol: 'circle',
                        barWidth: 15,
                        itemStyle: {
                            opacity: 0.8,
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 1,
                                    color: '#297DFC',
                                },
                                {
                                    offset: 0,
                                    color: '#06FDF5',
                                },
                            ]),
                        },
                        backgroundStyle: {
                            color: 'rgba(44, 118, 254, 0.2)'
                        },

                        // tooltip: {
                        //     trigger: 'item'
                        // },
                    },
                    {
                        name: '订单量',
                        data: data2.value,
                        type: 'line',
                        symbol: 'circle',
                        symbolSize: 5,
                        yAxisIndex: 1,
                        itemStyle: {
                            color: '#5c35f7'
                        }
                    },

                ],
                tooltip: {//鼠标悬浮提示数据
                    trigger: 'axis',
                    axisPointer: {
                        type: 'line'
                    },
                    // formatter: function (params) {
                    //     console.log(params, 2)
                    //     // return `<p>
                    //     //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                    //     //     }： ${params.data.account || 0} </span>

                    //     //       </p>`;
                    //     return `
                    //     <p style="color: #FFF; font-size: 14px; font-weight: normal;">${params[0].axisValue
                    //         }</p><br/>
                    //     <p>
                    //       <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数(笔)： ${params[0].value || 0} </span>
                    //     </p><br/> 
                    //      <p>
                    //       <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管金额(万)： ${params[1].value || 0} </span>
                    //      </p>`;
                    //     // return params.name
                    // },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },

                }
            };
            myChart.clear();
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
        // 环状图
        pieChart(data) {
            var myChart = this.$echarts.init(document.getElementById('pieChart'));
            var option = {
                // color: ['#0EDAE2', '#5D2CFE', '#E7C660', '#2C76FE'],
                color: ['#E7C660', '#0EDAE2', '#2C76FE'],

                title: {
                    show: true,
                    left: '43%',
                    top: '40%',
                    text: `  ${data.totalAmount}\n\n共计(万元)`,
                    textStyle: {
                        color: '#FFFFFF',
                        fontWeight: 500,
                        fontSize: 12
                    },
                },
                grid: {
                    left: '1%',
                    height: '100px',
                },
                tooltip: {
                    trigger: 'item',
                    axisPointer: {
                        type: 'shadow',
                    },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                    formatter: '{b} {d}%\n\n'
                },
                legend: {
                    top: '30%',
                    right: '-1%',
                    // icon: 'circle',
                    formatter: function (name) {
                        if (name == '商城交易') return `${name}  ${data.mallTrade + '%'}`
                        if (name == '活畜交易') return `${name}  ${data.liveTrade + '%'}`
                        if (name == '屠宰交易') return `${name}  ${data.slaughterTrade + '%'}`
                    },
                    textStyle: {
                        color: '#6FB6FF',
                        fontWeight: 400,
                        fontFamily: 'HarmonyOS Sans SC-Regular, HarmonyOS Sans SC'
                    },
                    orient: 'vertical',
                    itemGap: 30
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '70%'],
                        // avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center',
                            color: '#FFFFFF',
                            alignTo: 'labelLine'
                        },
                        // labelLine: {
                        //     show: true,
                        //     length: 5,
                        //     length2: 100,
                        //     lineStyle: {
                        //         color: '#73c0de',
                        //     }
                        // },
                        data: [
                            { value: data.mallTrade, name: '商城交易' },
                            { value: data.liveTrade, name: '活畜交易' },
                            { value: data.slaughterTrade, name: '屠宰交易' },
                        ]
                    }
                ]
            };
            myChart.clear();
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
        getList() {
            this.$http({
                url: 'screenapp-service/screenXmbRunCommand/select',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                    parentId: "9",
                    menuMark: "2"
                },
            }).then(res => {
                const data = res.data
                if (data.code == 200) {
                    var screenData = JSON.parse(data.result.screenData)
                    this.screenData = screenData
                    console.log(screenData, 'screen');
                    // this.info = data.result.screenName
                    this.totalTradeAmount = screenData.totalTradeAmount
                    this.mallTotalTradeAmount = screenData.mallTotalTradeAmount
                    this.liveTotalTradeAmount = screenData.liveTotalTradeAmount
                    this.slaughterTradeAmount = screenData.slaughterTradeAmount
                    this.tradeGrowTrend = screenData.tradeGrowTrend
                    this.myTradeGrowTrend = screenData.tradeGrowTrend.all
                    this.lineChart(this.myTradeGrowTrend.tradeAmountData, this.myTradeGrowTrend.orderSize)//传入交易金额、订单量
                    this.pieChart(screenData.tradeDisProp)
                    this.terrainAnalysis = screenData.terrainAnalysis.all
                    this.tableData = screenData.terrainAnalysis.all.operatingCenter//全部 默认 运营中心表格数据
                    this.change()
                    this.getMap()//获取地图数据

                }
            })
        },
        // 退出
        exitLogin() {
            this.hideModel()
        },
        getMap() {
            this.$http({
                url: 'screenapp-service/baseScreenEnterpriseInfo/select/mapData',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                },
            }).then(res => {
                if (res.data.code === 200) {
                    // console.log(res,'rers');
                    this.region = res.data.result.json;
                    // this.getData()
                    this.draw(this.region, this.terrainAnalysis.mapData)
                }
            })
        },
        draw(geoJson, data) {
            // 基于准备好的dom，初始化echarts实例
            console.log(data)
            var chart = this.$echarts.init(document.getElementById("chinaChart"));
            this.mapMainChart = chart
            geoJson.features.forEach((item) => {
                item['properties']['cp'] = item.properties.center
            })
            // var dataArr = []
            // data.forEach(item => {
            //     dataArr.push({
            //         name: item.name,
            //         value: item.position
            //     })
            // })
            data.forEach(item => {
                item.value = item.position

            })
            // this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            chart.hideLoading();
            chart.setOption({
                tooltip: {
                    // 提示框
                    trigger: "item",
                    padding: 5,
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                    // extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: (params) => {
                        // console.log(params, 'paa');
                        if (params.data.totalAmount) {
                            return `
                                     <p style=" font-size: 14px; font-weight: normal;">总交易额(万): ${params.data.totalAmount || 0}
                                        </p><br/>
                        <p>
                          <span style=" font-size: 14px; font-weight: normal;">商城交易额(万): ${params.data.mallTradeAmount || 0} </span>
                        </p><br/> 
                         <p>
                          <span style=" font-size: 14px; font-weight: normal;">活畜交易额(万): ${params.data.liveTradeAmount || 0}</span>
                         </p><br/> 
                          <p>
                          <span style=" font-size: 14px; font-weight: normal;">商屠宰收购交易额(万): ${params.data.slaughterTradeAmount || 0}</span>
                         </p>  `
                        }
                        if (params.data.mallTradeAmount) {
                            return `
                                     <p style=" font-size: 14px; font-weight: normal;">总交易额(万): ${params.data.mallTradeAmount || 0}
                                        </p> `
                        }
                        if (params.data.liveTradeAmount) {
                            return `
                                     <p style=" font-size: 14px; font-weight: normal;">总交易额(万): ${params.data.liveTradeAmount || 0}
                                        </p> `
                        }
                        if (params.data.slaughterTradeAmount) {
                            return `
                                     <p style=" font-size: 14px; font-weight: normal;">总交易额(万): ${params.data.slaughterTradeAmount || 0}
                                        </p> `
                        }
                        // if (params.name === '新疆维吾尔自治区') {
                        //     return `总交易额(万): ${data[0].totalAmount}<br/>
                        //     \n 商城交易额(万): ${data[0].mallTradeAmount} <br />
                        //    \n 活畜交易额(万): ${data[0].liveTradeAmount} <br />
                        //     \n 商屠宰收购交易额(万): ${data[0].slaughterTradeAmount}`
                        // }
                        // if (params.name === '内蒙古自治区') {
                        //     return `总交易额(万): ${data[1].totalAmount}<br/>
                        //     \n 商城交易额(万): ${data[1].mallTradeAmount} <br />
                        //    \n 活畜交易额(万): ${data[1].liveTradeAmount} <br />
                        //     \n 商屠宰收购交易额(万): ${data[1].slaughterTradeAmount}`
                        // }
                        // if (params.name === '陕西省') {
                        //     return `总交易额(万): ${data[2].totalAmount}<br/>
                        //     \n 商城交易额(万): ${data[2].mallTradeAmount} <br />
                        //    \n 活畜交易额(万): ${data[2].liveTradeAmount} <br />
                        //     \n 商屠宰收购交易额(万): ${data[2].slaughterTradeAmount}`
                        // }
                        // if (params.name === '黑龙江省') {
                        //     return `总交易额(万): ${data[3].totalAmount}<br/>
                        //     \n 商城交易额(万): ${data[3].mallTradeAmount} <br />
                        //    \n 活畜交易额(万): ${data[3].liveTradeAmount} <br />
                        //     \n 商屠宰收购交易额(万): ${data[3].slaughterTradeAmount}`
                        // }
                        // if (params.name === '吉林省') {
                        //     return `总交易额(万): ${data[4].totalAmount}<br/>
                        //     \n 商城交易额(万): ${data[4].mallTradeAmount} <br />
                        //    \n 活畜交易额(万): ${data[4].liveTradeAmount} <br />
                        //     \n 商屠宰收购交易额(万): ${data[4].slaughterTradeAmount}`
                        // }
                    }
                },
                // series: [
                geo: {
                    show: true,
                    // roam: true,
                    type: "map", // 系列类型
                    name: "map", // 系列名称
                    zoom: 1.2,
                    map: "china", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                    // data: data,
                    // selectedMode: 'multiple',
                    label: {
                        // properties.cp
                        // 标签的相关设置
                        show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                        // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                        position: 'top',
                        // offset: [-10, 5],
                        textStyle: {
                            // 标签的字体样式
                            color: "white", // 地图初始化区域字体颜色
                            fontSize: 12, // 字体大小
                            opacity: 1, // 字体透明度
                            backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                        },
                        // align: 'center',
                        // verticalAlign: 'middle'
                        // normal: {
                        //     show: true,
                        //     color: 'rgba(5, 176, 220, 1)',
                        //     fontSize: 1, //此处字体需做兼容适配

                        //     align: 'left',
                        //     verticalAlign: 'middle',
                        //     position: 'inside',
                        //     distance: 15,
                        // },
                        // emphasis: {
                        //     show: true,
                        //     color: '#ececec'
                        // }
                    },
                    select: {
                        itemStyle: {
                            areaColor: "#1E88E5",
                            borderColor: "#21bde6",
                            borderWidth: "1"
                        },
                        label: {
                            color: '#FFFFFF'
                        }
                    },
                    blur: {
                        itemStyle: {
                            areaColor: "#1E88E5",
                            borderColor: "#21bde6",
                            borderWidth: "1"
                        }
                    },
                    itemStyle: {
                        // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                        color: "rgba(255, 255, 255, 0.05)", // 地图板块的颜色
                        // color: '#082263',
                        // color: '#112d6a',
                        opacity: 1, // 图形的不透明度 [ default: 1 ]
                        borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                        borderColor: "#21bde6", // 图形描边的颜色。[ default: #333 ]
                        // normal: { // 默认地图区域样式
                        //     // areaColor: 'rgba(33,80,231,1)',
                        //     aeraColor:'#021355',
                        //     borderColor: "#4ECEE6",
                        //     borderWidth: 1,
                        //     shadowColor: "#2C99F6",
                        //     shadowOffsetY: 0,
                        //     shadowBlur: 25,
                        // },
                    },
                    emphasis: {
                        // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                        label: {
                            // label高亮时的配置
                            show: true,
                            textStyle: {
                                color: "#fff", // 高亮时标签颜色变为 白色
                                fontSize: 15, // 高亮时标签字体 变大
                            },
                            // formatter : function(params) {
                            //     console.log(params)
                            // }     
                        },
                        itemStyle: {
                            "areaColor": '#1E88E5'
                        }
                    },
                },
                // ]
                series: [
                    {
                        type: 'effectScatter',
                        coordinateSystem: 'geo',
                        effectType: 'ripple',
                        rippleEffect: {
                            color: '#00FFFF',
                            number: 3,
                            scale: 5,
                            brushType: 'stroke'
                        },
                        data: data,
                    },
                    // {
                    //     type: 'map',
                    //     name: "map",
                    //     geoIndex: 0,
                    //     data: data,
                    // },

                ],
                // visualMap: {
                //     show: false,
                //     min: 0,
                //     max: 300,
                //     inRange: {
                //         color: ['white', 'red']
                //     }
                // },
            });
            window.addEventListener('resize', () => {
                chart.resize()
            })
        },

    }
}
</script>
<style lang="scss">
.user {
    .el-input__inner {
        height: 0.75rem !important;
    }

    .el-range-editor.el-input__inner {
        padding: 0;
    }

    .el-date-editor {
        padding: 0.05rem 0;
        width: 160px !important;
        border: none;
        background-color: transparent;
        margin-left: .5rem;
        // background-color: #112d6a;
    }

    .el-date-editor .el-range-input {
        font-size: .15rem;
        background-color: transparent;
    }

    .el-date-editor .el-range-separator {
        font-size: .15rem;
        margin-top: 0.07rem;
        color: #fff;
        padding: 0.05rem .1rem 0 0;
    }

    .el-date-editor .el-range__close-icon {
        display: none;
    }

    .el-date-editor .el-range__icon {
        display: none;
    }

    .el-range-input {
        width: 75px !important;
        color: #FFFFFF !important;
        cursor: pointer;
    }



    .el-table td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
        border: none;
        padding: 0;
    }

    /*最外层透明*/
    .el-table,
    .el-table__expanded-cell {
        background-color: transparent;
    }

    /* 表格内背景颜色 */
    .el-table tr {
        // background: rgba(38, 103, 224, 0.08);
        background: transparent;
    }

    .el-table th {
        color: #f6f6f7;
        /* 字体颜色 */
        font-size: 0.18rem;
        background: rgba(38, 103, 224, 0.08) !important;
        /* 背景透明 */
        border: 0;
        height: 0.56rem;
        line-height: 0.56rem;
    }

    .el-table tr+.row_bg {
        background: rgba(255, 255, 255, 0.03);
    }

    .el-table tr,
    .el-table td {
        color: rgba(255, 255, 255, 0.5);
        font-size: 0.18rem;
        /* background-color: transparent ; */
        border: 0;
        height: 0.56rem;
        ;
        line-height: 0.56rem;
        ;
    }

    .el-table__body tr.current-row>td.el-table__cell,
    .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
        background: rgba(255, 255, 255, 0.1) !important;
        color: #FFFFFF;
    }

    .el-table::before {
        left: 0;
        bottom: 0;
        width: 100%;
        height: 0px;
    }

    tr td:last-child .el-tooltip {
        width: 5.8rem !important;
        text-align: center;
    }
    .el-table__header {
        // width: 606px;
        width: 100%!important;
        padding: 0 0.35rem!important;
    }
    .el-table__body{
        width: 100%!important;
        padding: 0 0.35rem!important;
    }
    .el-tooltip{
        min-width: 1.15rem!important;
        // text-align: center;
    }
    tr td:nth-child(2) .el-tooltip {
        min-width: 1.6rem!important;
    }
    /* 设置滚动条样式 */
    /*表格滚动条和字体颜色*/
    .table .el-table {
        border-bottom: 0;
        color: hsla(0, 0%, 100%, 0.6);
        // padding-right: 0.0625rem;
        margin: 0
    }


    /* 设置滚动条的样式 */
    ::-webkit-scrollbar {
        width: 0;
        /*滚动条粗细*/
    }

    /* 滚动槽 */
    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
        border-radius: 10px;
    }

    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
    }

    .el-tabs__active-bar {
        height: 0px;
    }

    .el-tabs__nav-wrap::after {
        height: 0px;
    }

    .el-tabs__nav {
        padding-left: 0.2rem;
    }


}
</style>
<style lang="scss" scoped>
.mains {
    width: 100%;
    // min-height: 11rem;
    // margin-top: 1.25rem;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    position: absolute;
    top: 1.25rem;
    left: 0;
    background: #050f37;

    .container {

        // height: 14.9rem;
        min-height: 15rem;
        opacity: 1;
        // margin: 1.25rem 1rem .6rem 1.06rem;
        margin: 0 .6rem .1rem 1.06rem;
        margin-bottom: 1rem;
        // border: 0.03rem solid #2C75FD;
        // background: #012D80;
        // position: absolute;
        // top: 0;
        // left: 0;
        background-image: url('../../assets/bg_group.png');
        background-size: 100% 100%;

        .header {
            width: 20.88rem;
            height: .81rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            opacity: 1;
            border-bottom: 0.01rem dashed #0f2963;
            // margin-left: .48rem;
            margin-left: .66rem;

            span {
                font-size: 0.3rem;
                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                font-weight: 500;
                color: #FFFFFF;
            }

        }

        .center {
            // width: 21.58rem;
            margin-top: .4rem;
            // margin-left: 1rem;
            margin-left: 1.2rem;
            display: flex;

            .nav {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                min-width: 1.54rem;
                height: 0.73rem;
                margin-left: 2.01rem;

                span {
                    font-size: 0.2rem;
                    font-family: PingFang SC-中等, PingFang SC;
                    color: #FFFFFF;
                }

                span:nth-child(2) {
                    font-size: 0.45rem;
                    font-family: PingFang SC-特粗, PingFang SC;
                    color: #FFBB00;
                    padding-top: .1rem;
                }

            }

            .nav:nth-child(1) {
                margin-left: 0;
            }
        }

        .conter {
            width: 19.71rem;
            height: 4.87rem;
            margin-top: .51rem;
            // margin-left: 1rem;
            margin-left: 1.2rem;
            display: flex;
            // background-color: pink;

            .left {
                width: 10.54rem;
                background: rgba(255, 255, 255, 0.05);

                .grow {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 9.81rem;
                    height: 0.75rem;
                    // opacity: 0.15;
                    border-bottom: 0.01rem dashed #021e5b;
                    margin: 0 .38rem 0 .35rem;

                    //  2C75FD
                    .grow_item {
                        font-size: 0.25rem;
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        font-weight: 400;
                        color: #FFFFFF;
                    }

                    .grow_ {
                        display: flex;
                        align-items: center;

                        img {
                            margin-left: .2rem;
                        }
                    }
                }

                .all {
                    margin-left: .34rem;
                    margin-top: .22rem;

                    span {
                        width: 0.63rem;
                        height: 0.31rem;
                        // background: #2C75FD;
                        background: rgba(44, 117, 253, 0.16);
                        ;
                        border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
                        font-size: 0.15rem;
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        font-weight: 400;
                        color: #FFFFFF;
                        opacity: 1;
                        padding: .1rem;
                        margin-left: .13rem;
                        cursor: pointer
                    }

                    .active {
                        background: #2C75FD;
                    }

                    span:nth-child(1) {
                        margin-left: 0;
                    }
                }

                .day {
                    height: .75rem;
                    margin-left: .83rem;
                    margin-top: .33rem;
                    display: flex;

                    .day_ {
                        min-width: 1.49rem;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: center;

                        span {
                            font-size: 0.18rem;
                            font-family: PingFang SC-中等, PingFang SC;
                            font-weight: normal;
                            color: #FFFFFF;
                        }

                        .day_item {
                            font-size: 0.38rem;
                            font-family: PingFang SC-特粗, PingFang SC;
                            font-weight: normal;
                            color: #05FBFE;

                            i {
                                font-size: 0.18rem;
                                font-family: PingFang SC-中等, PingFang SC;
                                font-weight: normal;
                                color: #FFFFFF;
                                font-style: normal
                            }
                        }
                    }

                    .day_:nth-child(2) {
                        margin-left: 1.17rem;
                    }

                    .day_:nth-child(3) {
                        margin-left: 2.6rem;

                        span {
                            font-size: 0.15rem;
                            font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;

                            i {
                                font-size: 0.23rem;
                                font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                                font-weight: bold;
                                color: #FFBB00;
                                padding: 0 .15rem;
                                font-style: normal
                            }
                        }
                    }
                }

                #lineChart {
                    width: 10.54rem;
                    height: 2.4rem;
                    margin-top: 0.12rem;
                }
            }

            .right {
                width: 8.79rem;
                background: rgba(255, 255, 255, 0.05);
                margin-left: .38rem;

                .grow {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 8.06rem;
                    height: 0.75rem;
                    // opacity: 0.15;
                    border-bottom: 0.01rem dashed #021e5b;
                    margin: 0 .38rem 0 .35rem;

                    .grow_item {
                        font-size: 0.25rem;
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        font-weight: 400;
                        color: #FFFFFF;
                    }

                    .grow_ {
                        display: flex;
                        align-items: center;

                        img {
                            margin-left: .2rem;
                        }
                    }
                }

                #pieChart {
                    width: 7.5rem;
                    height: 4rem;
                    margin-top: 0.12rem;
                }
            }
        }

        .footer {
            width: 19.7rem;
            height: 6.88rem;
            background: rgba(255, 255, 255, 0.05);
            opacity: 1;
            margin: .2rem .88rem .31rem 1rem;
            margin-left: 1.2rem;

            .grow {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 18.95rem;
                height: 0.75rem;
                // opacity: 0.15;
                border-bottom: 0.01rem dashed #021e5b;
                margin: 0 .38rem 0 .35rem;

                .grow_item {
                    font-size: 0.25rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                }

                .grow_ {
                    display: flex;
                    align-items: center;

                    img {
                        margin-left: .2rem;
                    }
                }
            }

            .footer_ {
                height: 6.11rem;
                margin-top: .1rem;
                display: flex;

                .left {
                    flex: 1;

                    .all {
                        margin-left: .34rem;
                        margin-top: .22rem;

                        span {
                            width: 0.63rem;
                            height: 0.31rem;
                            // background: #2C75FD;
                            background: rgba(44, 117, 253, 0.16);
                            ;
                            border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
                            font-size: 0.15rem;
                            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;
                            opacity: 1;
                            padding: .1rem;
                            margin-left: .13rem;
                            cursor: pointer
                        }

                        .active {
                            background: #2C75FD;
                        }

                        span:nth-child(1) {
                            margin-left: 0;
                        }
                    }

                    #chinaChart {
                        width: 9rem;
                        height: 5.41rem;
                        margin: auto;
                        margin-top: .2rem;

                    }
                }

                .right {
                    flex: 1;

                    .all {
                        margin-left: .34rem;
                        margin-top: .22rem;

                        span {
                            min-width: 0.63rem;
                            height: 0.31rem;
                            // background: #2C75FD;
                            background: rgba(44, 117, 253, 0.16);
                            border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
                            font-size: 0.15rem;
                            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;
                            opacity: 1;
                            padding: .1rem;
                            margin-left: .13rem;
                            cursor: pointer
                        }

                        .active {
                            background: #2C75FD;
                        }

                        span:nth-child(1) {
                            margin-left: 0;
                        }

                        span:last-child {
                            margin-left: 4.2rem;
                            font-size: 0.18rem;
                            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                            font-weight: 400;
                            color: #D8DFFE;
                            background: none;

                            i {
                                font-size: 0.23rem;
                                font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                                font-weight: bold;
                                color: #FFBB00;
                                font-style: normal;
                                padding-left: .2rem;
                            }
                        }

                        .only {
                            margin-left: 5.3rem !important;
                        }
                    }
                }
            }
        }
    }
}
</style>